import React from 'react'
import { AboutEl } from '../../elements'
import TextEditor from '../../../../../../../../../../../Modules/Notes/Components/TextEditor'
import { H5 } from '../../../../../../../../../../../Styles/typography'
import { Subscribe } from 'unstated'
import CourseStore from '../../../../../../../../../Store/CourseStore'
import Faq from './components/FAQ'

const About = () => {
  return (
    <Subscribe to={[CourseStore]}>
      {({ state: { description, objectives, preRequisites } }) => {
        return (
          <AboutEl>
            <div className='description'>
              <TextEditor
                minimal={true}
                defaultValue={description}
                readOnly={true}
              />
              <Faq />
            </div>
            <div className='right'>
              <div className='objectives'>
                <H5>Course Objectives</H5>
                <span className='separator' />
                <TextEditor
                  minimal={true}
                  defaultValue={objectives}
                  readOnly={true}
                />
              </div>
              <div className='prerequisites'>
                <H5>Course Prerequisites</H5>
                <span className='separator' />
                <TextEditor
                  minimal={true}
                  defaultValue={preRequisites}
                  readOnly={true}
                />
              </div>
            </div>
          </AboutEl>
        )
      }}
    </Subscribe>
  )
}

export default About
